module.exports = require('styled-jsx/style')
